<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4 mx-auto" >
                <template #default>بلفاروپلاستی   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5" >
                <template #default>بِلِفاروپلاستی یا جراحی ترمیمی پلک (به یونانی: blepharon، "پلک" + plassein "شکل دادن") یک عمل جراحی پلاستیک برای اصلاح عیب، بدشکلی و ناهنجاری پلک‌ها است و معمولاً برای اصلاح زیبایی ناحیه چشم در صورت انجام می‌شود.
   </template>
                </m-h4></template>
                </m-div><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/\u0628\u0644\u0641\u0627\u0631\u0648\u067e\u0644\u0627\u0633\u062a\u06cc\/Untitled-159.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/\u0628\u0644\u0641\u0627\u0631\u0648\u067e\u0644\u0627\u0633\u062a\u06cc\/Untitled-1578.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-4" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mSection200 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mSection200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
